<template>
    <div class="News">
        <menuBox :step="3"></menuBox>
        <div class="news-box">News</div>

        <div class="news-custom">
            <div class="text-box">
                <div class="title">Discover the Latest News and Industry Trends</div>
                <div class="text-info">Welcome to our Latest News page! Here, you can stay updated on the latest updates about our company, project developments, and industry trends. Subscribe to our newsletter for more exciting content. </div>
                <div class="attr-btn">More attractions</div>
            </div>
            <div class="text-list">
                <div class="analy-box">
                    <img src="../assets/news-4.png" alt="">
                    <div>Company Updates: </div>
                    <p>Stay informed about our latest news and project updates.</p>
                </div>
                <div class="analy-box">
                    <img src="../assets/news-5.png" alt="">
                    <div>Industry Trends: </div>
                    <p>Explore the latest trends and developments within the industry.</p>
                </div>
                <div class="analy-box">
                    <img src="../assets/news-6.png" alt="">
                    <div>Upcoming Events: </div>
                    <p>Preview our upcoming events and industry exhibitions.</p>
                </div>
                <div class="analy-box">
                    <img src="../assets/news-7.png" alt="">
                    <div>Success Stories: </div>
                    <p>Explore success stories and project case studies from our clients.</p>
                </div>
            </div>
        </div>

        <div class="say-item">
            <div class="say-box">
                <div class="title">what customers are saying</div>
                <div class="say-list">
                    <img src="../assets/news-11.png" alt="">
                    <div class="what-text">
                        <img src="../assets/news-2.png" alt="">
                        <div class="what-box">Trusted Partner</div>
                        <div class="what-title">I have been a loyal customer of this company, Hami-Happy, for a long time. They have provided me with excellent service and solutions. Their team is highly professional, offering me tremendous support and helping me achieve my business goals. I sincerely appreciate their trust and support.</div>
                        <div class="what-tlet">Indispensable Partner</div>
                        <div class="what-title">Working with Hami-Happy has been an absolute pleasure. Their commitment to excellence and their innovative solutions have greatly contributed to the success of my business endeavors. I am truly grateful for their consistent support and highly recommend their services.</div>
                    </div>
                </div>
            </div>
            <div class="say-iups">
                <img src="../assets/news-3.png" alt="">
                <div class="news-letter">
                    <div>join our newsletter</div>
                    <p>Stay updated with the latest news, offers, and updates by joining our newsletter today!</p>
                </div>
                <div class="input-box">
                    <input type="text" class="input-text" placeholder="Email Address">
                    <div class="btn">Subscribe</div>
                </div>
            </div>
        </div>

        <div class="technolo">
            <div class="title">Expanding Influence: <br> Across Diverse Demographics</div>

            <div class="img-list">
                <div class="item-box">
                    <img src="../assets/news-8.png" alt="">
                    <div class="aug-box">
                        <div class="aug">
                            <div>30</div>
                            <p>AUG</p>
                        </div>
                        <p>Reaching Broader Age Groups</p>
                    </div>
                </div>
                <div class="item-box">
                    <img src="../assets/news-9.png" alt="">
                    <div class="aug-box">
                        <div class="aug">
                            <div>50</div>
                            <p>AUG</p>
                        </div>
                        <p>Engaging Additional Geographic Locations</p>
                    </div>
                </div>
                <div class="item-box">
                    <img src="../assets/news-10.png" alt="">
                    <div class="aug-box">
                        <div class="aug">
                            <div>80</div>
                            <p>AUG</p>
                        </div>
                        <p>Connecting with Varied Cultural Backgrounds</p>
                    </div>
                </div>
            </div>
        </div>

        <footerBox :step="3"></footerBox>
    </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        }
    }
}
</script>

<style lang="less" scoped>
.news-box {
    padding: 116px 360px;
    background-color: #5B2CD4;
    font-weight: 500;
    font-size: 48px;
    color: #FFFFFF;
}

.news-custom {
    padding: 150px 360px;
    display: flex;
    justify-content: space-between;

    .text-box {
        width: 550px;
        text-align: left;

        .sbtitle {
            font-weight: 500;
            font-size: 24px;
            color: #6434E0;
        }

        .title {
            font-weight: bold;
            font-size: 46px;
            color: #333333;
            margin-top: 20px;
        }

        .text-info {
            font-weight: 400;
            font-size: 20px;
            color: #999999;
            margin-top: 24px;
        }

        .attr-btn {
            width: 267px;
            height: 80px;
            background: #1E1729;
            border-radius: 20px 20px 20px 20px;
            margin-top: 24px;
            font-weight: 400;
            font-size: 24px;
            color: #FFFFFF;
            text-align: center;
            line-height: 80px;
        }
    }

    .text-list {
        display: flex;
        // align-items: center;
        flex-wrap: wrap;
        width: 600px;
        justify-content: space-between;

        .analy-box {
            width: 237px;
            min-height: 236px;
            background: #FFFFFF;
            box-shadow: 0px 7px 32px 0px rgba(12, 59, 102, 0.15);
            border-radius: 20px 20px 20px 20px;
            padding: 20px 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 30px;

            img {
                width: 76px;
                height: 76px;
            }

            div {
                font-weight: 500;
                font-size: 24px;
                color: #333333;
                margin-top: 14px;
            }

            p {
                font-weight: 400;
                font-size: 18px;
                color: #333333;
                margin-top: 12px;
            }
        }
    }

}

.say-item {

    .say-box {
        background: url(../assets/news-1.png);
        height: 650px;
        background-size: 100% 100%;
        padding: 80px 360px;

        .sbtitle {
            font-weight: 500;
            font-size: 24px;
            color: #6434E0;
        }

        .title {
            font-weight: bold;
            font-size: 46px;
            color: #333333;
            margin-top: 20px;
        }

        .say-list {
            margin-top: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            img {
                width: 360px;
            }

            .what-text {
                width: 840px;

                img {
                    height: 40px;
                }

                .what-box {
                    margin-top: 40px;
                    font-weight: bold;
                    font-size: 28px;
                    color: #333333;
                }

                .what-title {
                    font-weight: 400;
                    font-size: 20px;
                    color: #999999;
                    margin-top: 20px;
                }

                .what-tlet {
                    margin-top: 70px;
                    font-weight: bold;
                    font-size: 28px;
                    color: #333333;
                }
            }
        }
    }

    .say-iups {
        width: 1099px;
        height: 110px;
        background: #5B2CD4;
        border-radius: 60px 60px 60px 60px;
        margin: auto;
        margin-top: -100px;
        padding: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
            width: 130px;
        }

        .news-letter {
            width: 450px;

            div {
                font-weight: bold;
                font-size: 40px;
                color: #FFFFFF;
            }

            p {
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                margin-top: 20px;
            }
        }

        .input-box {
            width: 400px;
            height: 76px;
            background: #FFFFFF;
            border-radius: 20px 20px 20px 20px;
            display: flex;
            align-items: center;
            overflow: hidden;
            justify-content: space-between;
            padding: 0px 20px;

            .input-text {
                padding: 0px 20px;
                height: 76px;
                border: none;
                outline: medium;
            }

            .btn {
                width: 133px;
                height: 60px;
                background: #1E1729;
                border-radius: 20px 20px 20px 20px;
                text-align: center;
                font-weight: 500;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 60px;
                // margin-right: 20px;
            }
        }
    }
}

.technolo {
    padding: 150px 360px;
    text-align: center;
    position: relative;

    .sbtitle {
        font-weight: 500;
        font-size: 24px;
        color: #6434E0;
    }

    .title {
        font-weight: bold;
        font-size: 46px;
        color: #333333;
        margin-top: 20px;
    }

    .img-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 80px;
        position: relative;

        .item-box {
            position: relative;

            img {
                width: 380px;
                z-index: 1;
            }

            .aug-box {
                width: 300px;
                min-height: 150px;
                background: #FFFFFF;
                border-radius: 40px 40px 40px 40px;
                border: 2px solid #D9D9D9;
                padding: 0px 40px 40px 40px;
                margin-top: -76px;
                position: relative;
                z-index: 2;

                .aug {
                    width: 127px;
                    height: 107px;
                    background: #5F2DDD;
                    border-radius: 10px 10px 10px 10px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin-top: -50px;

                    div {
                        font-weight: bold;
                        font-size: 38px;
                        color: #FFFFFF;
                    }

                    p {
                        font-weight: 400;
                        font-size: 28px;
                        color: #FFFFFF;
                        margin-top: 0px;
                    }
                }

                p {
                    font-weight: bold;
                    font-size: 24px;
                    color: #333333;
                    margin-top: 20px;
                    text-align: left;
                }
            }

        }
    }
}
</style>
